import { render, staticRenderFns } from "./StudentProfileResponses.vue?vue&type=template&id=c0e28978&scoped=true"
import script from "./StudentProfileResponses.vue?vue&type=script&lang=js"
export * from "./StudentProfileResponses.vue?vue&type=script&lang=js"
import style0 from "./StudentProfileResponses.vue?vue&type=style&index=0&id=c0e28978&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0e28978",
  null
  
)

export default component.exports